import { ReducerRegistry } from '../base/redux';

import {
    CLOSE_PARTICIPANTS_PANE_MODAL,
    MODERATION_PANE_CLOSE,
    MODERATION_PANE_OPEN,
    OPEN_PARTICIPANTS_PANE_MODAL,
    PARTICIPANTS_PANE_CLOSE,
    PARTICIPANTS_PANE_OPEN
} from './actionTypes';
import { REDUCER_KEY } from './constants';

const DEFAULT_STATE = {
    isModerationOpen: false,
    isOpen: false,
    isParticipantsPaneModalOpen: false
};

/**
 * Listen for actions that mutate the participants pane state.
 */
ReducerRegistry.register(
    REDUCER_KEY, (state = DEFAULT_STATE, action) => {
        switch (action.type) {
        case PARTICIPANTS_PANE_CLOSE:
            return {
                ...state,
                isOpen: false
            };

        case PARTICIPANTS_PANE_OPEN:

            // Both panes dock to the same side, so only one of them can be up.
            return {
                ...state,
                isModerationOpen: false,
                isOpen: true
            };

        case MODERATION_PANE_CLOSE:
            return {
                ...state,
                isModerationOpen: false
            };

        case MODERATION_PANE_OPEN:
            return {
                ...state,
                isModerationOpen: true,
                isOpen: false
            };
        case OPEN_PARTICIPANTS_PANE_MODAL:
            return {
                ...state,
                isParticipantsPaneModalOpen: true
            };
        case CLOSE_PARTICIPANTS_PANE_MODAL:
            return {
                ...state,
                isParticipantsPaneModalOpen: false
            };

        default:
            return state;
        }
    }
);
